
import { Vue, Component, Prop } from "vue-property-decorator";
import { CustomFieldDto, CustomFieldTypes } from '@/store/custom-fields/types';
import { customFieldMixins } from "@/mixins/customFieldMixins";
import { namespace } from 'vuex-class';
import { truncateString } from '@/filters';

const CustomFields = namespace("customFields");
const { convertCustomFieldDateValue } = customFieldMixins.methods;

@Component({
	components: {
	},
	filters: { truncateString }
})
export default class CustomFieldPriorityDisplay extends Vue {
	@Prop({required:false}) private priorities: any;

	@CustomFields.State contactCustomFields: CustomFieldDto[];

	private customFieldCharacterLimit: number = 30;

	private getCustomFieldType(customFieldValue): string {
		const field = this.contactCustomFields.find(field => field.id.toString() == customFieldValue.id)
		if (field) {
			return CustomFieldTypes[field.customFieldTypeId]
		}
		return "";
	}

	private getConvertedCustomFieldDateValue(date: string): string {
		return convertCustomFieldDateValue(date);
	}
}
